module.exports = __webpack_public_path__ + "static/media/Sgnature.e15586e5.png";